<template>
    <v-dialog v-model="isView" eager scrollable>
        <v-card class="mt-3 pa-1">
            <Title :title="title">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="mt-2 pa-0">
                <Editor 
                    ref="editor"
                    @onClickSaveImage="onClickSaveImage" />
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import Editor from '@/components/tools/ImageEditor';
    import Confirm from '@/components/tools/ConfirmDialog';
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Editor,
            Title,
            TitleButton,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                params: null,
                title: "画像編集"
            }
        },
        methods: {
            onClickSaveImage: function (params) {
                console.log(params)

                const self = this

                this.$refs.confirm.show({
                    title: "画像へのコメント",
                    message: "画像へのコメントを保存しますか？",
                    buttonYes: "保存する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.params.layers = []
                        for (var i=0; i<params.layers.length; i++) {                            
                            const imageData = params.layers[i].context.getImageData(0, 0, params.layers[i].canvas.width, params.layers[i].canvas.height)
                            const isEmptyLayer = imageData.data.find((v)=>v != 0) == null ? true : false
                            if (!isEmptyLayer) {
                                const image = params.layers[i].canvas.toDataURL("image/png")
                                const layerParams = params.layers[i]
                                layerParams.image = image
                                self.params.layers.push(layerParams)
                            }
                        }
                        self.$emit("onAddImageComment", self.params)
                        self.isView = false
                        return true
                    },
                })
            },
            show: function (params) {
                this.isView = true
                this.params = params
                this.title = params.title
                this.$refs.editor.show(params)
            }
        }
    }
</script>
